/** @format */

(function () {
  $(document).ready(function () {
    // Main Nav Dropdown
    $("#primary-nav li").hover(
      function () {
        $(this).addClass("hover");
        $("ul.submenu", this).fadeIn(200);
      },
      function () {
        $(this).removeClass("hover");
        $("ul.submenu", this).fadeOut(200);
      }
    );
  });

  $(".privary-navigation__list li a").click(function () {
    $(".privary-navigation__list li a").removeClass("active");
    $(this).addClass("active");
  });

  window.onload = function () {
    /*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

    scrollDownAction(20, "scroll");

    scrollW();

    window.addEventListener("scroll", function () {
      scrollW();
    });
  };
})();
